<div class="share-list-select-component gap-8" fxLayout="column">
    <div class="share-list-select-component__header" fxLayout="column">
        <dsn-input
            [size]="'medium'"
            [type]="'text'"
            [placeholder]="'Pesquisar usuários cadastrados'"
            [disabled]="false"
            [value]="''"
            [name]="'search'"
            [id]="'search-field'"
            [isInvalid]="false"
            [noValidate]="true"
            [icon]="'fa-solid fa-magnifying-glass'"
            [invalidMessage]="''"
            (input)="handleSearch($event)"
        ></dsn-input>
    </div>
    <div
        class="share-list-select-component__section gap-8 dsn-scrollbar overflow-y scroll-secondary"
        style="padding-right: var(--spacing-8)"
        fxLayout="column"
        fxFlex
    >
        <ul
            fxLayout="column"
            class="share-list-select-component__section-contacts gap-8"
        >
            @for (
                category of filteredCategories;
                let catIdx = $index;
                track $index
            ) {
                <li fxLayout="column" class="gap-8">
                    <div
                        fxLayout="row"
                        fxLayoutAlign="space-between center"
                        class="padding-8 share-list-select-component__section-contacts__category"
                    >
                        <span class="text-14-semi-bold color-text-primary">{{
                            category.name
                        }}</span>
                    </div>
                    <ul fxLayout="column" class="gap-8">
                        @if (
                            category._id !== "contabilidade" && !disableActions
                        ) {
                            <li fxLayout="column" fxLayoutAlign="center center">
                                <dsn-button
                                    [prelabel]="''"
                                    [label]="'Adicionar contato'"
                                    [type]="'secondary'"
                                    [size]="'medium'"
                                    [disabled]="false"
                                    [iconLeft]="''"
                                    [iconRight]="''"
                                    [active]="true"
                                    [width]="'full'"
                                    [justify]="'center'"
                                    [fontWeight]="'bold'"
                                    [onlyIcon]="''"
                                    (onClick)="onAddContact(category)"
                                ></dsn-button>
                            </li>
                        }

                        @for (
                            contact of category.contacts;
                            let conIdx = $index;
                            track $index
                        ) {
                            <li
                                class="share-list-select-component__section__contact {{
                                    filterType === 'whatsapp' &&
                                        !contact?.contact &&
                                        'cursor-disabled'
                                }}"
                                (click)="
                                    onUpdateDisabledContact(
                                        contact,
                                        category._id
                                    )
                                "
                                fxLayout="row"
                                fxLayoutAlign="space-between none"
                                style="padding: var(--spacing-4); height: 26px"
                            >
                                <dsn-checkbox
                                    [disabled]="
                                        filterType === 'whatsapp' &&
                                        !contact?.contact
                                    "
                                    [checkboxTooltip]="
                                        filterType === 'whatsapp' &&
                                        !contact?.contact
                                            ? 'Contato sem WhatsApp cadastrado. Adicione o número para selecionar.'
                                            : ''
                                    "
                                    [(ngModel)]="contact.checked"
                                    (ngModelChange)="
                                        updateSelectAllState(
                                            contact,
                                            category._id,
                                            contact._id
                                        )
                                    "
                                    [label]="contact.name"
                                    [placeholder]="'Placeholder'"
                                    [fontWeight]="'semi-bold'"
                                    [id]="'username-field-' + contact._id"
                                    [name]="'username-' + contact._id"
                                ></dsn-checkbox>

                                <div fxLayout="row" fxLayoutAlign="none center">
                                    @if (
                                        contact?.contact &&
                                        contact?.contact !== "undefined"
                                    ) {
                                        <span
                                            class="m-right-8 color-text-hint text-14-regular"
                                            >{{
                                                contact.contact | mask: "phone"
                                            }}</span
                                        >
                                    }

                                    @if (
                                        (category?._id !== "contabilidade" &&
                                            !disableActions) ||
                                        (category?._id === "contabilidade" &&
                                            user.props?.role ===
                                                "Contabilidade")
                                    ) {
                                        <dsn-button-rounded
                                            style="
                                                background-color: var(
                                                    --background-color-primary
                                                );
                                                border-radius: var(
                                                    --border-radius-8
                                                );
                                            "
                                            [type]="'secondary'"
                                            [icon]="'fa-solid fa-user-pen'"
                                            class="absolute-button"
                                            [disabled]="false"
                                            [size]="'medium'"
                                            [active]="false"
                                            (onClick)="
                                                onUpdateContact(
                                                    contact,
                                                    category._id
                                                )
                                            "
                                        ></dsn-button-rounded>
                                    }
                                </div>
                            </li>
                        }
                    </ul>
                </li>
            }
        </ul>
        <div
            class="share-list-select-component__section-divider"
            fxLayout="column"
        ></div>
        <div
            class="share-wpp-dialog-component__column-section gap-8"
            fxLayout="column"
        >
            <label
                class="text-12-regular color-text-primary"
                for="emailInputChips"
                ><i
                    class="fa-solid fa-envelope-open-text m-right-8 color-text-secondary"
                    style="font-size: var(--font-size-18)"
                ></i
                >{{ label }}</label
            >
            <dsn-text-chips
                [chips]="chips"
                [type]="typeChips"
                [id]="'emailInputChips'"
                [placeholder]="placeholderChips"
                [readOnly]="false"
                [disabled]="false"
                [name]="'chips'"
                [isInvalid]="false"
                [invalidMessage]="invalidMessageChips"
                [noValidate]="false"
                [id]="''"
                [noSpacing]="false"
            ></dsn-text-chips>
            <p class="color-text-primary text-12-regular">
                *As funcionalidades do Dash <strong>são limitadas</strong> para
                usuários não cadastrados.
            </p>
        </div>
    </div>
</div>
